export default __webpack_public_path__ + "static/media/ILPlatform_Programme5-7.9d0b5260.png";